<template>
  <div>
    <div class="content-header">
      <ol class="breadcrumb">
        <li>
          <router-link :to="{ name: 'couponList'}">
            优惠券列表
          </router-link>
        </li>
        <li class="active">添加/更新</li>
      </ol>
    </div>
    <div class="content-from">
      <el-form ref="formName" :model="saveModel" :rules="rules" label-width="140px" style="width:80%;margin:0 auto;">
        <el-form-item label="优惠券名称:" prop="name">
          <el-input v-model="saveModel.name" placeholder="请输入优惠券名称"></el-input>
        </el-form-item>
        <el-form-item label="优惠券描述:" prop="remark">
          <el-input v-model="saveModel.remark" placeholder="请输入优惠券描述"></el-input>
        </el-form-item>
        <el-form-item label="(所需/兑换）积分:" prop="needIntegral">
          <el-input-number v-model="saveModel.needIntegral" :min="1" placeholder="请输入所需积分"></el-input-number>
        </el-form-item>
        <el-form-item width="50px" label="抵用金额:" prop="offsetAmountMoney">
          <el-input-number v-model="saveModel.offsetAmountMoney" :min="1" :precision="2"
                           placeholder="请输入抵用金额"></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="saveCoupon('formName')">确认</el-button>
          <el-button size="small" @click="resetForm('formName')">重置</el-button>
          <el-button size="small" @click="$router.back(-1)">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      saveModel: {
        status: 'NORMAL',
        type: 'COMMON'
      },
      rules: {
        name: [{
          required: true,
          message: "请输入商品名称",
          trigger: "blur"
        }],
        remark: [{
          required: true,
          message: "请输入优惠券描述",
          trigger: "blur"
        }],
        needIntegral: [{
          required: true,
          message: "请输入(所需/兑换）积分",
          trigger: "blur"
        }],
        offsetAmountMoney: [{
          required: true,
          message: "请输入抵用金额",
          trigger: "blur"
        }],
      },
      couponId: ''
    }
  },
  mounted() {
    const _this = this;
    _this.serverUrl = config.hostUrl;
    _this.couponId = _this.$route.query.couponId;
    _this.couponId && _this.detailCoupon();
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    saveCoupon(formName) {
      var _this = this;
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.$common.my_ajax({
            url: 'coupon/saveCoupon',
            contentType: 'application/json',
            data: _this.saveModel,
            success: function (response) {
              _this.$message({
                message: '保存成功',
                type: 'success',
                duration: 1000,
                onClose: function () {
                  _this.$router.back(-1);
                }
              });
            }
          });
        } else {
          return false;
        }
      })
    },
    detailCoupon() {
      var _this = this;
      _this.$common.my_ajax({
        url: 'coupon/detailCoupon',
        data: {
          couponId: _this.couponId
        },
        success: function (response) {
          _this.saveModel = response.item;
        }
      });
    },
    gotoList() {
      this.$router.push({
        name: 'couponList',
      });
    }
  },
}
</script>

<style scoped>
.col-sm-3 {
  width: 20%;
}

.property-box {
  width: auto !important;
  max-width: 678px;
}

.can-shu {
  width: 160px;
  margin-bottom: 20px;
}
</style>
